export const DataTablePageSize = 25;

export type DataTableSort = {
  name: string;
  dir: string;
};

export type DataTableLocationState = {
  limit?: number;
  page?: number;
  query?: string;
  view?: string;
};
